module.exports = __webpack_public_path__ + "static/img/face_recognition_header.b94b5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/face_recognition_header.png
// module id = c+YK
// module chunks = 1